"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Event_1 = __importDefault(require("../Event"));
const index_1 = require("../index");
const Participant_1 = require("../../models/Participant");
/**
 * The ActiveParticipants model gathers information about all participants who joined a specific conference. The model includes the conference [alias](#conferencealias) and [ID](#conferenceid), the [list](#participants) of conference participants, and the [number](#participantcount) of all participants who joined the conference.
 */
class ActiveParticipants extends Event_1.default {
    /** @ignore */
    constructor() {
        super(index_1.EventType.ActiveParticipants);
        /** Participants who joined the conference.*/
        this.participants = [];
        /** The number of all participants who joined the conference.*/
        this.participantCount = 0;
    }
    /** @ignore */
    static fromData(data) {
        const activeParticipants = new ActiveParticipants();
        activeParticipants.participants = data.participants.map((participantData) => {
            const participant = new Participant_1.Participant(participantData.userId, participantData.participantStatus, participantData.participantType);
            participant.updateName(participantData.externalName);
            participant.updateExternalId(participantData.externalId);
            return participant;
        });
        activeParticipants.conferenceId = data.conference.confId;
        activeParticipants.conferenceAlias = data.conference.confAlias;
        activeParticipants.participantCount = data.participantCount === data.participants.length ? data.participantCount : data.participants.length;
        return activeParticipants;
    }
}
exports.default = ActiveParticipants;
